import { queryOptions, useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';
import { API_ROUTES, QUERY_KEYS } from '@/config/constants';
import type {
  InvoiceRecordsResponse,
  MonthlySpendResponse,
} from '@/features/payments/types/invoice-record';

export const fetchInvoiceRecords = async (
  wholesalerId: string,
): Promise<InvoiceRecordsResponse> => {
  const { data } = await api.get<InvoiceRecordsResponse>(API_ROUTES.billing.invoiceRecords, {
    headers: { 'x-wholesaler-id': wholesalerId },
  });
  return data;
};

export const fetchMonthlySpend = async (wholesalerId: string): Promise<MonthlySpendResponse> => {
  const { data } = await api.get<MonthlySpendResponse>(API_ROUTES.billing.monthlySpend, {
    headers: { 'x-wholesaler-id': wholesalerId },
  });
  return data;
};

export const getInvoiceRecordsQueryOptions = (wholesalerId: string) =>
  queryOptions({
    queryKey: QUERY_KEYS.billing.invoiceRecords(wholesalerId),
    queryFn: () => fetchInvoiceRecords(wholesalerId),
    staleTime: Infinity,
  });

export const getMonthlySpendQueryOptions = (wholesalerId: string) =>
  queryOptions({
    queryKey: QUERY_KEYS.billing.monthlySpend(wholesalerId),
    queryFn: () => fetchMonthlySpend(wholesalerId),
    staleTime: Infinity,
  });

export const useInvoiceRecords = (wholesalerId: string | null) =>
  useQuery({
    ...getInvoiceRecordsQueryOptions(wholesalerId ?? ''),
    enabled: wholesalerId != null,
  });

export const useMonthlySpend = (wholesalerId: string | null) =>
  useQuery({
    ...getMonthlySpendQueryOptions(wholesalerId ?? ''),
    enabled: wholesalerId != null,
  });
